import { render, staticRenderFns } from "./Logouticon.vue?vue&type=template&id=027237c7&"
import script from "./Logouticon.vue?vue&type=script&lang=ts&"
export * from "./Logouticon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports